import { useCallback, useEffect, useState } from 'react';

import { MediaObject, Player } from '../../../types';

const useShowLoader = (player: Player | null, sources: MediaObject[]) => {
  const [showLoader, setShowLoader] = useState(false);

  const onWaiting = useCallback(() => setShowLoader(true), []);
  const onCanPlay = useCallback(() => setShowLoader(false), []);

  useEffect(() => {
    if (!player || !sources.length) return;

    player.on('waiting', onWaiting);
    player.on('canplay', onCanPlay);

    return () => {
      player.off('waiting', onWaiting);
      player.off('canplay', onCanPlay);
    };
  }, [player, sources]);

  return showLoader;
};

export default useShowLoader;
